import React, { useContext } from 'react';

import { NavLink } from 'react-router-dom';

import { AuthContext } from '@/core/auth/AuthContext';
import UserInviteConfirmModal from '@/core/users/UserInvite/UserInviteConfirmModal';
import { UserInviteContext } from '@/core/users/UserInvite/UserInviteContext';
import { UserInviteEditPermissionsContainer } from '@/core/users/UserInvite/UserInviteEditPermissionsContainer';
import { UserInviteEditTeamsContainer } from '@/core/users/UserInvite/UserInviteEditTeamsContainer';
import { UserInviteHeader } from '@/core/users/UserInvite/UserInviteHeader';
import { UserInviteReplyToAddress } from '@/core/users/UserInvite/UserInviteReplyToAddress';
import {
  GRID_CLASSES,
  GRID_COLUMNS,
  UserPermissionsContentWidth,
} from '@/core/users/UserPermissions/UserPermissionsContentWidth';
import { UsersNavigationBar } from '@/core/users/UsersNavigationBar';
import { ReactComponent as ArrowLeft } from '@/icons/arrow_left.svg';
import routes from '@/routes';

export function UserInvite () {
  const { currentAccount, hasCoreAccess } = useContext(AuthContext);
  const { billingRate, sendInvite, showConfirmModal, toggleConfirmModal } = useContext(UserInviteContext);

  return (
    <>
      <div className="z-10 border-b border-gray-300">
        <UsersNavigationBar>
          <NavLink to={routes.users.self} className="flex items-center p-6 -ml-6">
            <ArrowLeft className="w-5 h-4 mr-3" />
            User Management
          </NavLink>
        </UsersNavigationBar>
      </div>
      <main className="min-h-screen text-gray-800 pb-60">
        <UserInviteHeader />
        <UserPermissionsContentWidth>
          <UserInviteEditPermissionsContainer />
          <Divider />
          {hasCoreAccess && (
            <>
              <UserInviteEditTeamsContainer />
              <Divider />
            </>
          )}
          <UserInviteReplyToAddress />
        </UserPermissionsContentWidth>
      </main>
      <UserInviteConfirmModal
        account={currentAccount!}
        onClose={toggleConfirmModal}
        onSubmit={sendInvite}
        open={showConfirmModal}
        rate={billingRate}
      />
    </>
  );
}

function Divider () {
  return (
    <div className={GRID_CLASSES} style={{ gridTemplateColumns: GRID_COLUMNS }}>
      <div className="border-b border-gray-300 col-start-2 col-span-full" />
    </div>
  );
}
